import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Autocomplete} from "@material-ui/lab";
import {Icon, IconButton, InputAdornment, TextField, Typography} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setFocus} from "../../app/app.slice";
import {multiLanguageValue} from "../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    popper: {
        left: '80px !important',
        top: '-10px !important'
    }
}))
const SearchBar = (props) => {
    const {options} = props;
    const [inputValue, setInputValue] = useState('');
    const {application} = useSelector(state => state.app);
    const {userLanguage} = useSelector(state => state.app);
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();

    function onChange(e, v) {
        if (v.url) {
            const urlValidate = v.url.startsWith('/') ? v.url : '/' + v.url;
            history.push('/' + application + urlValidate)
        }
        setInputValue('')
        dispatch(setFocus('content'))
    }

    return (
        <div style={{width: '80%'}}>
            <Autocomplete
                onKeyDown={(e) => e.stopPropagation()}
                id={'searchBar'}
                options={options}
                disableClearable
                onChange={onChange}
                freeSolo
                value={''}
                fullWidth
                inputValue={inputValue}
                className={'sb-menu-searchbar-field'}
                classes={{
                    paper: classes.paper,
                    popper: classes.popper
                }}
                onInputChange={(e, v) => setInputValue(v)}
                getOptionLabel={i => multiLanguageValue(i.label, userLanguage) || ""}
                renderOption={(option) => (
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Icon color={'action'} fontSize={"small"}>
                            {option.icon}
                        </Icon>
                        <div style={{paddingLeft: 5}}>
                            <Typography style={{fontSize: 14}}>{multiLanguageValue(option.label, userLanguage)}</Typography>
                        </div>

                    </div>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={'Search...'}
                        variant={'outlined'}
                        fullWidth
                        // className={'horizontal-fields-table'}
                        type={'search'}
                        size={"small"}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <InputAdornment position={'start'}>
                                    <IconButton
                                        disabled
                                        style={{padding: 0}}
                                        aria-label="search menu items"
                                    >
                                        <Icon>search</Icon>
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                )}
            />
        </div>
    )
}
export default SearchBar